"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixSubstackColors = fixSubstackColors;
const tex_syntax_1 = require("./tex-syntax");
/*
Replaces substacks that start with a color and then contain text
separated by a linebreak

e.g.
\substack{
    \red {
        \text{Hellllllo} \\
        \text{fancy world}
    }
}

and works by distributing the color into the text
e.g.
\substack{
        \text{\red{Hellllllo}} \\
        \text{\red{fancy world}}
}

If we don't do this then the line break is completely ignored
and the color doens't show up properly

*/
function fixSubstackColors(tex) {
    // Pre-flight to make sure there's work to do in this expression
    if (!tex.match(new RegExp(`\\\\substack{\\s*\\\\${tex_syntax_1.color}{\\s*\\\\text`))) {
        return tex;
    }
    return tex.replace(new RegExp(`\\\\substack(${(0, tex_syntax_1.block)(3)})`, "g"), (wholeString, innerBlock) => {
        const factoredColor = innerBlock
            .slice(1, -1)
            .replace(new RegExp(`\\\\(${tex_syntax_1.color})(${(0, tex_syntax_1.block)(3)})`, "g"), (whole, matchedColor, inner) => {
            if (!inner.slice(1, -1).trim().startsWith("\\text")) {
                return whole;
            }
            return inner
                .slice(1, -1)
                .replace(new RegExp(`\\\\text(${(0, tex_syntax_1.block)(3)})`, "g"), `\\text{\\${matchedColor}$1}`);
        });
        return `\\substack{${factoredColor}}`;
    });
}
